import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient, private constant: Constant) { 
    
  }

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  validateCustomer(id): Observable<any> {
    return this.http.get(this.constant.API_ENDPOINT + "/customer-account/" + id , this.httpOptions);
  }

  getCustomerDetail(): Observable<any> {
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/customer-detail', this.httpOptions);
  }

  register(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + "/api/v1/register-customer", JSON.stringify(req), this.httpOptions);
  }

  updateCustomerDetail(req): Observable<any> {
    return this.http.put<any>(this.constant.API_DOMAIN + '/api/v1/customer-detail-update', req,
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(e) {
  console.log(e);
  if(e.error && e.error.message) {
    return throwError(e.error.message);
  }
  return throwError('');
  }
}